import { Component, Input, OnInit } from '@angular/core';
import { AgentDto, AppRoleDto, DynamicProperties } from '../../../../../../service/dto';
import { HttpAppRoleService } from '../../../../../../service/http-app-role.service';


class RoleWrapper{
	role!: AppRoleDto;
	checked!: boolean;
}
@Component({
  selector: 'app-agent-admin-view-app-roles',
  standalone: false,
  templateUrl: './agent-admin-view-app-roles.component.html',
  styleUrl: './agent-admin-view-app-roles.component.scss'
})
export class AgentAdminViewAppRolesComponent implements OnInit{
	@Input() agent!: AgentDto;
	roles!: AppRoleDto[]
	wrappers: RoleWrapper[] = [];

	constructor(private appRoleService: HttpAppRoleService){}

	ngOnInit() {
		this.appRoleService.getAll().subscribe(result => {
			this.init(result);
		});
	}
	private init(input: AppRoleDto[]){
		this.roles = input;
		this.wrappers = [];
		const agentRoles: AppRoleDto[] = this.agent?.roles ?? [];
		for (const role of input) {
			const w = new RoleWrapper();
			w.role = role;
			w.checked = agentRoles.some(ar => ar.id === role.id);
			this.wrappers.push(w);
		}
	}
	change(){
		this.agent.roles = this.wrappers.filter(item => item.checked == true).map(item => item.role);
	}
	doSubmit(){
		console.log()
		this.agent.roles = this.wrappers.filter(item => item.checked == true).map(item => item.role);
		this.appRoleService.editAgentRoles(this.agent).subscribe(result => {
			this.agent.roles=result.roles;
			this.init(this.roles);
		})
	}
}
